export const SET_SELECTED_TEAM = 'SET_SELECTED_TEAM'
export const SET_SELECTED_DATABOX = 'SET_SELECTED_DATABOX'
export const SET_DATABOX_DOCUMENTS = 'SET_DATABOX_DOCUMENTS'
export const SET_PAGE_SIZE = 'SET_PAGE_SIZE'
export const SET_TEAM_TAGS = 'SET_TEAM_TAGS'
export const SET_IS_DRAWER_OPEN = 'SET_IS_DRAWER_OPEN'
export const SET_CREATE_DATA_BOX_STATE = 'SET_CREATE_DATA_BOX_STATE'
export const SET_DATA_BOX_EDIT_MODE = 'SET_DATA_BOX_EDIT_MODE'
export const SET_ALL_DATA_BOXES = 'SET_ALL_DATA_BOXES'
export const SET_ALL_SETTING_OPS = 'SET_ALL_SETTING_OPS'
export const SET_ALL_TEAMS = 'SET_ALL_TEAMS'
export const RELOAD_TEAMS = 'RELOAD_TEAMS'
export const SET_DATABOX_TEAM = 'SET_DATABOX_TEAM'
export const SET_ALL_CATEGORIES = 'SET_ALL_CATEGORIES'
export const SET_ALL_TAG_LEVELS = 'SET_ALL_TAG_LEVELS'
export const SET_PLAIN_DATABOXES = 'SET_PLAIN_DATABOXES'
export const SET_CURRENT_THREAD = 'SET_CURRENT_THREAD'
